'use strict';
angular.module('TurneroApp').component('coAsistenciaDarTurno', {
    bindings: {
        centroAtencionSeleccionado: '<'
    },
    controller: [
        '$window',
        'turnosService',
        '$state',
        '$rootScope',
        '$scope',
        'signalrDotNetCoreService',
        'utilsService',
        '$element',
        'TurneroAppConstant',
        function ($window, turnosService, $state, $rootScope, $scope, signalrService, utilsService, $element, TurneroAppConstant) {
            var ctrl = this;
            ctrl.Turno = {};
            ctrl.Dar_Turnos_Multiples = false;
            ctrl.permisos = TurneroAppConstant.Permisos;
            ctrl.Modalidades = TurneroAppConstant.Modalidades;
            ctrl.limpiarMemoria = function () {
                ctrl.personaConfig = {
                    numero_seccion: 2
                }
                
                ctrl.Filtro = null;
                ctrl.showAgendas = false;
                ctrl.Turno.orden_de_Llegada = false;
                ctrl.Turno.calendario = false;
                ctrl.TurnoInfo = {};
                ctrl.DatosTurno = null;
                $rootScope.$broadcast('LimpiarPersonas', null);
            }

            $scope.$on('cambioPersonaSeleccionada', function (event, personaSeleccionada) {
                ctrl.Ciudadano = null;
                if (personaSeleccionada) {
                    ctrl.Ciudadano = personaSeleccionada;
                    ctrl.TurnoInfo.Ciudadano = personaSeleccionada;
                }
            });

            ctrl.$onChanges = function () {
                ctrl.limpiarMemoria();
                ctrl.centroAtencionSeleccionado.id && ctrl.cargaCombos();

            };

            ctrl.cargaCombos = function () {
                ctrl.promiseTramite = turnosService.Get_TramitesYAgendas({ 'id_centro_atencion': ctrl.centroAtencionSeleccionado.id }).$promise.then(function (result) {
                    ctrl.Tramites = result.Data;
                }).catch(function (error) {
                    utilsService.errores(error);
                })
            }

            ctrl.seleccionarAgenda = function (tramite) {
                if (ctrl.DatosTurno) { ctrl.DatosTurno.Agenda = null; ctrl.DatosTurno.Tramite = null; };
                ctrl.Agenda = null;

                if (tramite.seleccionado) {
                    ctrl.showAgendas = true;
                    ctrl.TurnoInfo.Tramite = tramite;
                    ctrl.promiseAgenda = turnosService.Get_AgendasXTramite({ 'id_tramite_relevado': tramite.id, 'id_centro_atencion': ctrl.centroAtencionSeleccionado.id }).$promise.then(function (result) {
                        ctrl.Agendas = result.Data;
                    }).catch(function (error) {
                        utilsService.errores(error);
                    })
                } else {
                    ctrl.validarModalidades(tramite)
                    ctrl.showAgendas = false;
                    ctrl.promiseAgenda = true
                }
            }

            ctrl.validarModalidades = function (agenda) {
                ctrl.TurnoInfo.Agenda = agenda
                if (agenda.seleccionado == false) {
                    ctrl.Turno.orden_de_Llegada = true;
                    ctrl.Turno.calendario = false;
                } else {
                    ctrl.Turno.orden_de_Llegada = agenda.Orden_Llegada == 1 ? true : false;
                    ctrl.Turno.calendario = agenda.Presencial == 1 ? true : false;
                }

            }

            ctrl.darTurnoOrdenDeLlegada = function () {
                var filtro = {
                    Id_Tramite_Relevado: ctrl.TurnoInfo.Agenda.seleccionado ? ctrl.TurnoInfo.Agenda.id : (ctrl.TurnoInfo.Tramite ? ctrl.TurnoInfo.Tramite.id : 0)
                    , Id_Agenda: !ctrl.TurnoInfo.Agenda.seleccionado ? ctrl.TurnoInfo.Agenda.id : (ctrl.TurnoInfo.Tramite ? ctrl.TurnoInfo.Tramite.id : 0)
                    , Id_Sexo: ctrl.TurnoInfo.Ciudadano.Datos_RegistroCivil == null ? null : ctrl.TurnoInfo.Ciudadano.Datos_RegistroCivil.Id_Sexo
                    , Nro_Documento: ctrl.TurnoInfo.Ciudadano.Datos_RegistroCivil == null ? null : ctrl.TurnoInfo.Ciudadano.Datos_RegistroCivil.Nro_Documento
                    , Pai_Cod_Pais: ctrl.TurnoInfo.Ciudadano.Datos_RegistroCivil == null ? null : (ctrl.TurnoInfo.Ciudadano.Datos_RegistroCivil.Pai_Cod_Pais ? ctrl.TurnoInfo.Ciudadano.Datos_RegistroCivil.Pai_Cod_Pais : null)
                    , Id_Numero: ctrl.TurnoInfo.Ciudadano.Datos_RegistroCivil == null ? null : ctrl.TurnoInfo.Ciudadano.Datos_RegistroCivil.Id_Numero
                    , N_Usuario_Cidi: ctrl.TurnoInfo.Ciudadano.Datos_Cidi.N_Ciudadano_Cidi
                }

                turnosService.Get_Sobreturno(filtro).$promise.then(function (result) {
                    //result.Data.Permite_Sobreturno:{0= turnos normal
                    //             1= Sobreturnos
                    //             2= No puede dar turnos}
                    //result.Data.Motivo: 
                    //              1= Máximo de turnos por día
                    //              2= fuera de horario
                    //              3= Máximo de turnos por persona
                    //              4= Máximo de turnos por trámite
                    if (result.Data.Permite_Sobreturno == 0) {
                        ctrl.prioridad();
                    } else if (result.Data.Permite_Sobreturno == 1) {
                        swal({
                            title: '¿Dar sobreturno?',
                            html: 'Está emitiendo un turno por orden de llegada fuera de los horarios de atención establecidos para este trámite o bien por encima del máximo de turnos diarios configurado en la agenda o el usuario ya tiene turnos activos. ¿Desea continuar?',
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#004b81',
                            cancelButtonColor: 'rgb(170, 170, 170)',
                            confirmButtonText: "Si",
                            cancelButtonText: "No",
                            allowEscapeKey: false,
                            allowOutsideClick: false
                        }).then(function (isConfirm) {
                            if (isConfirm) {
                                ctrl.prioridad();
                            }

                        }, function (error) {
                            if (error != 'cancel') {
                                swal.close();
                                swal({
                                    title: 'No se pudo dar el turno',
                                    html: "Algo ocurrió  y no se pudo completar la acción.<br/> Intente nuevamente o comuníquese con soporte. </br><span style='display:none'> " + error.data.ExceptionMessage + "</span>",
                                    type: "error",
                                    confirmButtonColor: '#004b81',
                                    confirmButtonText: 'Aceptar',
                                    allowEscapeKey: false,
                                    allowOutsideClick: false
                                });
                            }
                        })
                    } else if (result.Data.Permite_Sobreturno == 2) {
                        if (result.Data.Motivo === 3) {
                            swal({
                                title: 'No se pueden dar más turnos',
                                html: "Usted ya se encuentra anunciado en esta agenda",
                                type: "warning",
                                confirmButtonColor: '#004b81',
                                confirmButtonText: 'Aceptar',
                                allowEscapeKey: false,
                                allowOutsideClick: false
                            });
                        } else {
                            var mensaje = "No se pueden dar mas turnos por orden de llegada para esta agenda.";
                            if (result.Data.Motivo === 2) {
                                mensaje = "No se pueden dar turnos por orden de llegada porque se encuentra fuera del horario configurado para esta agenda";
                        }

                            swal({
                                title: 'No se pueden dar más turnos',
                                html: mensaje,
                                type: "warning",
                                confirmButtonColor: '#004b81',
                                confirmButtonText: 'Aceptar',
                                allowEscapeKey: false,
                                allowOutsideClick: false
                            });
                        }
                        } else {
                            swal({
                            title: 'No se pueden dar más turnos',
                            html: "No se pueden dar más turnos por orden de llegada para esta agenda.",
                            type: "warning",
                            confirmButtonColor: '#004b81',
                            confirmButtonText: 'Aceptar',
                            allowEscapeKey: false,
                            allowOutsideClick: false
                        });
                    } 
                }).catch(function (error) {
                    utilsService.errores(error);
                });
            }

            ctrl.prioridad = function () {
                swal({
                    title: '¿Requiere atención prioritaria?',
                    html: 'Conforme a la Ley Provincial 9.131, si el ciudadano es una mujer embarazada, un/a anciano/a, un/a discapacitado/a o una persona con motricidad limitada, se le atenderá con prioridad. </br> De ser alguno de estos el caso, presione <strong>Sí</strong>.</br>De lo contrario, presione <strong>No</strong>.',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#004b81',
                    cancelButtonColor: 'rgb(170, 170, 170)',
                    confirmButtonText: "Si",
                    cancelButtonText: "No",
                    allowEscapeKey: false,
                    allowOutsideClick: false
                }).then(function () {
                    ctrl.PostOrdenDeLlegada(true);
                }, function (error) {
                    if (error != 'cancel') {
                        swal.close();
                        swal({
                            title: 'No se pudo dar el turno',
                            html: "Algo ocurrió  y no se pudo completar la acción.<br/> Intente nuevamente o comuníquese con soporte. </br><span style='display:none'> " + error.data.ExceptionMessage + "</span>",
                            type: 'error',
                            confirmButtonColor: '#004b81',
                            confirmButtonText: 'Aceptar',
                            allowEscapeKey: false,
                            allowOutsideClick: false
                        });
                    } else {
                        ctrl.PostOrdenDeLlegada(false);
                    }
                })
            }

            ctrl.imprimirTicket = function (item) {
                turnosService.Get_Turno_Imprime_ticket({ 'Id_Turno': item.id }).$promise.then(function (resultado) {
                    if (resultado.Data == 'S') {
                        ctrl.configuracion = {
                            Id_Turno: item.id,
                            Modulo: 'AST',
                            N_Equipo: null
                        }
                    }
                })

            }

            ctrl.PostOrdenDeLlegada = function (prioridad) {
                // VALIDACION: evitar enviar Id_Centro_Atencion inválido (0/undefined)
                if (!ctrl.centroAtencionSeleccionado || !ctrl.centroAtencionSeleccionado.id || parseInt(ctrl.centroAtencionSeleccionado.id) === 0) {
                    console.error('PostOrdenDeLlegada abortado: centroAtencionSeleccionado.id inválido', ctrl.centroAtencionSeleccionado);
                    swal({
                        title: 'Error',
                        html: 'No se ha seleccionado un centro de atención válido. Verifique la configuración.',
                        type: 'error',
                        confirmButtonColor: '#004b81',
                        confirmButtonText: "Ok",
                        allowEscapeKey: false,
                        allowOutsideClick: false
                    });
                    return;
                }

                var Turno = {
                    Id_Tramite_Relevado: ctrl.TurnoInfo.Agenda.seleccionado ? ctrl.TurnoInfo.Agenda.id : (ctrl.TurnoInfo.Tramite ? ctrl.TurnoInfo.Tramite.id : 0),
                    Sujeto_Ley_9131: prioridad ? 'D' : '',
                    Id_Agenda: !ctrl.TurnoInfo.Agenda.seleccionado ? ctrl.TurnoInfo.Agenda.id : ctrl.TurnoInfo.Tramite.id,
                    Id_Sexo: ctrl.TurnoInfo.Ciudadano.Datos_RegistroCivil == null ? null : ctrl.TurnoInfo.Ciudadano.Datos_RegistroCivil.Id_Sexo,
                    Nro_Documento: ctrl.TurnoInfo.Ciudadano.Datos_RegistroCivil == null ? ctrl.TurnoInfo.Ciudadano.Datos_Cidi.N_Ciudadano_Cidi : ctrl.TurnoInfo.Ciudadano.Datos_RegistroCivil.Nro_Documento,
                    Pai_Cod_Pais: ctrl.TurnoInfo.Ciudadano.Datos_RegistroCivil == null ? null : (ctrl.TurnoInfo.Ciudadano.Datos_RegistroCivil.Pai_Cod_Pais ? ctrl.TurnoInfo.Ciudadano.Datos_RegistroCivil.Pai_Cod_Pais : null),
                    Id_Numero: ctrl.TurnoInfo.Ciudadano.Datos_RegistroCivil == null ? null : ctrl.TurnoInfo.Ciudadano.Datos_RegistroCivil.Id_Numero,
                    N_Usuario_Cidi: ctrl.TurnoInfo.Ciudadano.Datos_Cidi.N_Ciudadano_Cidi,
                    Id_Prioridad: prioridad ? 1 : 0,//1 = Muy Alta (Ley);  0= Sin Prioridad
                    Id_Centro_Atencion: ctrl.centroAtencionSeleccionado.id
                }
                turnosService.Post_Turno_Orden_Llegada(Turno).$promise.then(function (resultado) {
                    //console.info("Desde el backend se invocó a TraerTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + resultado.Data.id + ".");
                    //envio la notificacion hub
                    /*signalrService.startHub(TurneroAppConstant.HubNames.TURNOS).then(function (hub) {
                        //actualizo ese turno en atención
                        hub.invoke('TraerTurnoAtencion', ctrl.centroAtencionSeleccionado.id, resultado.Data.id).then(function () {
                            console.info("Se invocó a TraerTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + resultado.Data.id + ".");
                        }).catch(function (err) {
                            console.error("Falló invocación a TraerTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + resultado.Data.id + ": " + err.toString());
                        });
                    });*/

                    ctrl.imprimirTicket(resultado.Data);
                    swal.close();
                    var Nombre_Ciudadano = (ctrl.TurnoInfo.Ciudadano.Datos_RegistroCivil == null ? ctrl.TurnoInfo.Ciudadano.Datos_Cidi.NombreYApellido : ctrl.TurnoInfo.Ciudadano.Datos_RegistroCivil.Nombre);
                    swal({
                        title: 'Turno generado',
                        html: 'Se ha registrado correctamente el turno <strong> ' + resultado.Data.text + '</strong> a nombre de <strong>' + Nombre_Ciudadano + '</strong>.<br/>Se ha emitido el ticket correspondiente',
                        type: 'success',
                        confirmButtonColor: '#004b81',
                        confirmButtonText: 'Aceptar',
                        allowEscapeKey: false,
                        allowOutsideClick: false
                    }).then(function () {
                        ctrl.limpiarMemoria();
                        ctrl.centroAtencionSeleccionado.id && ctrl.cargaCombos();
                    }, function (error) {
                        swal.close();
                        swal({
                            title: 'No se pudo generar el turno',
                            html: "Algo ocurrió  y no se pudo completar la acción.<br/> Intente nuevamente o comuníquese con soporte. </br><span style='display:none'> " + error.data.ExceptionMessage + "</span>",
                            type: 'error',
                            confirmButtonColor: '#004b81',
                            confirmButtonText: 'Aceptar',
                            allowEscapeKey: false,
                            allowOutsideClick: false
                        });
                    });

                }).catch(function (error) {
                    utilsService.errores(error);
                })
            }

            ctrl.verFechasCalendario = function (bool) {
                ctrl.calendarioReadOnly = null;
                ctrl.DatosTurno = null;
                ctrl.Agenda = {};
                ctrl.DatosTurno = ctrl.Turno;
                ctrl.Agenda.Agenda = ctrl.Filtro.Agenda
                ctrl.DatosTurno.Agenda = ctrl.Agenda.Agenda
                ctrl.Agenda.Tramite = ctrl.Filtro.Tramite
                ctrl.DatosTurno.Tramite = ctrl.Agenda.Tramite
                ctrl.Agenda.CentroSeleccionado = ctrl.centroAtencionSeleccionado
                ctrl.DatosTurno.centroSeleccionado = ctrl.Agenda.CentroSeleccionado
                if (ctrl.Ciudadano && ctrl.Ciudadano.Datos_RegistroCivil) {
                    ctrl.Ciudadano.Datos_RegistroCivil.NombreAs = ctrl.Ciudadano.Datos_RegistroCivil.Nombre.split(',')[1].trim();
                    ctrl.Ciudadano.Datos_RegistroCivil.ApellidoAs = ctrl.Ciudadano.Datos_RegistroCivil.Nombre.split(',')[0].trim();
                }
                ctrl.calendarioReadOnly = bool;
                ctrl.mostrarCalendario = true;
            }


            $element.find('input').on('keydown', function (ev) {
                ctrl.searchTerm = ctrl.searchTerm
                ev.stopPropagation();
            });

            ctrl.searchTerm = {
                text: ''
            };
            ctrl.clearSearchTerm = function () {
                ctrl.searchTerm = {
                    text: ''
                };
            };
            ctrl.ignoreAccents = function (item) {
                if (!ctrl.searchTerm.text)
                    return true;
                var text = utilsService.removeAccents(item.text.toLowerCase())
                var search = utilsService.removeAccents(ctrl.searchTerm.text.toLowerCase());
                return text.indexOf(search) > -1;
            };

            ctrl.ocultarCalendario = function (bool) {
                ctrl.DatosTurno = {};
                ctrl.calendarioReadOnly = true;
                ctrl.mostrarCalendario = bool;
                $scope.$apply();
            }

            $scope.$on('cancelarConfirmacion', function (event, bool) {
                ctrl.mostrarConfirmacion = bool;
                ctrl.mostrarCalendario = false;
                ctrl.limpiarMemoria()
            });

            ctrl.MostrarConfirmacion = function (data) {
                ctrl.calendarioReadOnly = false;
                ctrl.mostrarCalendario = false;
                ctrl.DatosTurno.Turno = data;
                ctrl.mostrarConfirmacion = true;
                $scope.$apply();
            }

            $scope.$on('volverACalendario', function (event, bool) {
                ctrl.mostrarCalendario = bool;
                ctrl.calendarioReadOnly = bool;
                ctrl.mostrarConfirmacion = !bool;
                $scope.$apply();

            })
        }],
    template: require('./asistencia_darTurno.html')
});



// WEBPACK FOOTER //
// ./app/components/asistencia/asistencia_darTurnoComponent.js